import Config from "../Config";
import Requisicao from "./RequisicaoService";

class SendMailService {
    static async sendMail(form) {
        return Requisicao.post(Config.urlBaseApi + 'send-mail', form);
    }
}

export default SendMailService;